/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BaseCellDTO } from './baseCellDTO';
import { GeoTestRegionsLocationDTO } from './geoTestRegionsLocationDTO';
import { BaseMetricDTO } from './baseMetricDTO';
import { OccupiedDateRangeDTO } from './occupiedDateRangeDTO';


export interface GeoTestRegionsCellDTO { 
    /**
     * Unique identifier for the test cell
     */
    id: number;
    cellName: BaseCellDTO;
    cellSize: BaseMetricDTO;
    /**
     * Cell ranking order (lower is better for test cell selection)
     */
    cellRank: number;
    /**
     * Geographic locations assigned to this cell
     */
    locations: Array<GeoTestRegionsLocationDTO>;
    /**
     * Anchor locations that serve as reference points for the cell
     */
    anchorLocations: Array<GeoTestRegionsLocationDTO>;
    /**
     * Geographic scope IDs defining the cell boundary
     */
    geoScopeIds: Array<number>;
    /**
     * Geographic granularity type (DMA, REGION, CITY, ZIP)
     */
    geoSplitType: GeoTestRegionsCellDTO.GeoSplitTypeEnum;
    /**
     * Display label for the geographic granularity type. Normal-cased (e.g. \'City\'); \'State\' for REGION; \'Markets\' for DMA/COMSCORE_MARKET when the vendor is Meta.
     */
    geoSplitTypeLabel: string;
    /**
     * Occupied spans including cool-down
     */
    occupiedRanges?: Array<OccupiedDateRangeDTO>;
}
export namespace GeoTestRegionsCellDTO {
    export type GeoSplitTypeEnum = 'CITY' | 'REGION' | 'COUNTRY' | 'DMA' | 'ZIP';
    export const GeoSplitTypeEnum = {
        City: 'CITY' as GeoSplitTypeEnum,
        Region: 'REGION' as GeoSplitTypeEnum,
        Country: 'COUNTRY' as GeoSplitTypeEnum,
        Dma: 'DMA' as GeoSplitTypeEnum,
        Zip: 'ZIP' as GeoSplitTypeEnum
    };
}


